export const BASE_BREAKPOINT_MOBILE = '896px'
